<div class="wccard p-3 mb-1">
    <app-talent-insights-ai *ngIf="companydataAI" [jobDemandCount]="hasJobDemand" [requestaidata]="companydataAI" [insightstabname]="'company'" [dataPending] = "getDataPendingStatus()"
        [totalcount]="totalResultCount"></app-talent-insights-ai>
</div>
<div class="wccard p-3 mb-1">

    <p class="f-16 font-weight-600 mb-5">Which companies are employing this
        talent?</p>

    <div>

        <div *ngIf="!currentcompanies?.data?.length">
            <div class="loader text-center" *ngIf="!isApiCalled">
                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            </div>
            <div *ngIf="isApiCalled">
                <p class="text-center small p-5 text-484b59">No data to display</p>
            </div>
        </div>
        <div class="mt-2" *ngIf="currentcompanies?.data?.length">
            <table mat-table [dataSource]="currentcompanies" class="mat-elevation-z8"
                style="width: 100%; box-shadow: none;" matSort #companysort="matSort" (matSortChange)="manualSort()">

                <!-- key -->
                <ng-container matColumnDef="key">
                    <th mat-header-cell mat-header-cell *matHeaderCellDef class="col-4">
                        <p class="text-9696 f-12 m-0">{{tableHeaderObj['TopCompanies']}}</p>
                    </th>
                    <td class="col-2" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                        <div class="d-flex">
                            <div *ngIf="!element.companylogo" [ngClass]="{'logobgcolor':!element?.companylogo}"
                                style="width: 30px;" class="compnaylogoplaceholder"><i
                                    class="fa-solid fa-buildings"></i></div>
                            <div class="compnaylogoplaceholder" *ngIf="element.companylogo"><img
                                    src={{element.companylogo}} alt="company_logo"></div>
                            <!-- <div class="ml-3 f-14 text-484b59">{{element.key | titlecase}}</div> -->

                            <p class="f-16 icon-color mb-1 f-14 position-relative companyHover">
                                <span class="" (mouseenter)="getCompanyInfo(element?.key)">
                                    <span class="position-relative text-capitalize"
                                        [ngClass]="{'dstooltip pointer':primaryCompanyInformation?.website, companyHover: primaryCompanyInformation?.website}">
                                        <div class="ml-3 f-14 text-484b59">{{element.key | titlecase}}</div>
                                        <span class="dstooltip-content">
                                            <app-company-hover-modal [companyInformation]="primaryCompanyInformation" *ngIf="primaryCompanyInformation"></app-company-hover-modal>
                                        </span>
                                    </span>
                                </span>
                            </p>
                        </div>
                    </td>
                </ng-container>

                <!-- doc_count -->
                <ng-container matColumnDef="doc_count">
                    <th class="" mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by doc_count">
                        <p class="text-9696 f-12 m-0">{{tableHeaderObj['TalentCount']}}</p>
                    </th>
                    <td class="text-484b59 font-weight-600" mat-cell *matCellDef="let element">
                        <span class="pointer"
                            (click)="handelRedirection('company', element.key)">{{element.doc_count | number}}</span>
                    </td>
                </ng-container>

                <!-- Attrition -->
                <ng-container matColumnDef="attrition">
                    <th class="" mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by attrition">
                        <p class="text-9696 f-12 m-0">{{tableHeaderObj['Attrition']}}</p>
                    </th>
                    <td class="text-484b59 font-weight-600" mat-cell *matCellDef="let element">
                        <div *ngIf="!hasAttritionData" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <span class="pointer"
                            (click)="handelRedirection('recentcompanyattrition', element.key)">{{element.attrition |
                            number}}</span>
                    </td>
                </ng-container>
                <!-- One year growth -->
                <ng-container matColumnDef="oneyeargrowth">
                    <th class="" mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by oneyeargrowth">
                        <p class="text-9696 f-12 m-0">{{tableHeaderObj['Growth']}} </p>
                    </th>
                    <td class="text-484b59 font-weight-600" mat-cell *matCellDef="let element">
                        <div *ngIf="!hasoneyeargrowth" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <span class="pointer"
                            (click)="handelRedirection('recentcompanyhires', element.key)">{{element.oneyeargrowth |
                            number}}</span>
                    </td>
                </ng-container>
   <ng-container matColumnDef="job_doc_count">
                <th class=""  *matHeaderCellDef mat-header-cell >
                    <p class="text-9696 f-12 m-0"   [ngbTooltip]="jobdemand">{{tableHeaderObj['JobDemand']}}</p>
                              <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12 ">
                     <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
          <span class="" *ngIf="element?.job_doc_count != 0" (click)="hasJobListingAccess &&  openJoblistSlider(element.key)" [class.pointer]="hasJobListingAccess">{{element?.job_doc_count | number}}</span>
          <span class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>
                </td>
            </ng-container>

             <ng-container matColumnDef="median_salary">
                <th class=""  *matHeaderCellDef mat-header-cell>
                    <p class="text-9696 f-12 m-0"  ><span [ngbTooltip]="mediansalarytooltip">{{tableHeaderObj['MedianSalary']}}</span>
                       <span class="dropdown ats-dropBtn ml-2">

              <span class="dropdown-toggle text-webbtree-green f-14" type="button" id="userDropdownButton" (click)="clearCurrency()"
                appDropdownToggle><i class="fa-solid {{target_fav_icon}}" *ngIf="target_fav_icon != 'fa-money-bill'"></i>
                {{target_fav_icon == 'fa-money-bill' ? currency : ''}}
                <span class="down ml-1"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
</span>
              <span class="dropdown-menu" aria-labelledby="userDropdownButton"
                style="width: -webkit-fill-available; padding: 10px;">
                <div class="search-input">
                  <i class="fa-solid fa-magnifying-glass search-icon"></i>

                  <input data-testid="auto-app-report-company-input-1" class="wc-form-control no-shadow w-100 inputheight mb-0 mt-0 mx-0" placeholder="Enter currency"
                    [(ngModel)]="currency" (keyup)="onTypeAheadSearch($event)"
                    (keydown.tab)="handleTabOpen($event)" />
                </div>

                <div *ngIf="filteredCurrencies?.length">
                  <span class="dropdown-item pointer d-flex align-items-center f-14 font-weight-400"
                    *ngFor="let cl of filteredCurrencies" (click)="selectedItem(cl)"
                    style="padding: 10px 10px!important;">
                    {{ cl.target_currency }}
                  </span>
                </div>
              </span>
            </span>
                       <ng-template #mediansalarytooltip>
                      <p class="f-12 font-weight-600 mb-1">About Salary Estimates</p>
                      <p class="f-12 mb-1">Salary range is based on employer-declared compensation shared in job postings. This reflects market-reported averages and may not capture privately negotiated or undisclosed salary bands.</p>
                      <p class="f-12">Salary and job post metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                    </p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12 ">
                   <div *ngIf="hasMedianSalary" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
<span *ngIf="element?.median_salary != 'N/A'" class="" [innerHTML]="element.median_salary"  ></span>
                  <span *ngIf="element?.confidence_score == 'very high' || element?.confidence_score == 'high'" matTooltip='{{element?.confidence_score | titlecase}} confidence'
            [matTooltipClass]="{ 'small-tooltip text-black': true }"><i class="fa-sharp fa-solid fa-shield-check ml-1" style="color: #2E93A1;"></i></span>
                    <span *ngIf="element?.median_salary == 'N/A'" matTooltip='We’re actively expanding salary coverage for this role. More data will be available as market signals strengthen.'
                  [matTooltipClass]="{ 'small-tooltip text-black': true }" style="font-family: Arial, sans-serif;">&mdash;</span>

                </td>
            </ng-container>

                <!-- %total -->
                <ng-container matColumnDef="graph">
                    <th class="" mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by Diversity">
                        <p class="text-9696 f-12">{{tableHeaderObj['DiversityRatio']}} </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <div *ngIf="hasDiversityData" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div> -->
                        <div class="progress align-items-center" style="background-color: #fff;height: 12px!important;">
                            <div class="mr-1 text-484b59">{{element.male ? element.male+'%': '0%'}} </div>
                            <i class="fas fa-male mr-1" matTooltip="Men {{element?.male}}%"
                                [matTooltipClass]="{ 'red-tooltip text-black': true }"
                                style="color: #B9CFF9 !important;"></i>
                            <!-- <div class="progress-bar" role="progressbar" matTooltip="Men {{element?.male}}%"
                                [matTooltipClass]="{ 'red-tooltip text-black': true }"
                                [ngStyle]="{'width.%': element.male}" aria-valuenow="element.male" aria-valuemin="0"
                                aria-valuemax="100" style="background-color: #95e1d3!important;"></div>
                            <div class="progress-bar" matTooltip="Women {{element?.female}}%"
                                [matTooltipClass]="{ 'red-tooltip text-black': true }"
                                style="background-color: #FFD3A3!important;" role="progressbar"
                                [ngStyle]="{'width.%': element.female}" aria-valuenow="element.female" aria-valuemin="0"
                                aria-valuemax="100"></div> -->
                            <i class="fa-regular fa-pipe text-9696"></i>
                            <i class="fas fa-female ml-1" matTooltip="Women {{element?.female}}%"
                                [matTooltipClass]="{ 'red-tooltip text-black': true }"
                                style="color: #FFD6F3 !important;"> </i>
                            <div class="ml-1 text-484b59">{{element.female ? element.female+'%':'0%'}}</div>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>


    </div>
</div>

<div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 10">
 <ngb-pagination
  [collectionSize]="totalCount <=50 ? totalCount : 50"
  [pageSize]="pageSize"
  [page]="currentPage"
  [maxSize]="5"
  [rotate]="false"
  [directionLinks]="false"
  [boundaryLinks]="false"
  [ellipses]="false"
  (pageChange)="setPage($event)">
</ngb-pagination>

</div>
<app-insights-joblist [data]="toOpenSliderFromTabSubject.asObservable()" [events]="sendDataToSliderSubject.asObservable()"></app-insights-joblist>
